import { render, staticRenderFns } from "./FbInput.vue?vue&type=template&id=0f029cc0"
import script from "./FbInput.vue?vue&type=script&lang=js"
export * from "./FbInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports